<template>
  <h2 class="heading">User-based Authorization</h2>
  <div style="width: 95%; margin:5px auto;height:35px;">
    <span style="padding:0px 12px;color:#888;">User:</span>
    <el-select v-model="userId" class="m-2" placeholder="Select User" @change="selectUser()" style="width:300px;">
        <el-option v-for="usr in allUsers" :key="usr.id" :label="usr.fullname" :value="usr.id"/>
    </el-select>
    <el-button style="margin-left:20px;" @click="saveAuthorization" type="primary">Save Authorization</el-button>
    <span v-if="loading" style="display:inline-block; margin-left:20px; vertical-align:middle;">
        <img src="@/assets/loading.gif" style="height:24px;"/>
    </span>
    <span v-if="success" class="successMsg">Saved authorization successfully!</span>
    <span class="errMsg" v-if="errMsg != ''">{{errMsg}}</span>
    <el-button style="margin-left:20px;float:right" @click="$router.push('userList')">All Users</el-button>

    <el-button style="float:right" @click="$router.push('authorizeBySystem')">System-based Authorization</el-button>
  </div>

  <el-table :data="allSystemRoles" stripe="true" height="95%" style="width: 95%; margin:15px auto;">
    <el-table-column prop="name" label="System" width="240"/>
    <el-table-column prop="boolList" label="Roles" align="left">
        <template #default="scope">
            <span v-for="(item, index) in scope.row.boolList" class="role" :class="{active : item.bool}"
                :key="index" @click="selectRole(scope.row.name, item.name)">{{item.name}}</span>
        </template>
    </el-table-column>
  </el-table>
</template>

<script>
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

export default {
    data() {
        return {
            userId: null,
            allUsers: [],
            allSystemRoles:[],
            systemRoleMap: new Map(),
            errMsg: '',
            success: false,
            loading: false,
            global,
        }
    },
    async created() {
        this.global.index = "auth";
        this.allUsers = await this.global.getAllUsers();
    },  
    async mounted() {
        let result = await AXIOS("/auth/getAllSystemRoles");
        this.errMsg = '';
        if (result.success) {
            this.allSystemRoles = result.data;
            for (var i = 0; i < this.allSystemRoles.length; i++) {
                let system = this.allSystemRoles[i].name;
                let boolList = this.allSystemRoles[i].boolList;
                for (var j = 0; j < boolList.length; j++) {
                    let role = boolList[j].name;
                    this.systemRoleMap.set(role+'@'+system, boolList[j]);
                }
            }
        } else {
            this.errMsg = result.errMsg;
        }

        let userId = this.$route.query.userId;
        if (userId) {
            this.userId = parseInt(userId);
            this.selectUser();
        }
    },
    methods: {
        selectRole(system, role) {
            let boolVO = this.systemRoleMap.get(role+'@'+system);
            boolVO.bool = !boolVO.bool;
        },
        clearAllRoles() {
            for (var i = 0; i < this.allSystemRoles.length; i++) {
                var systemRoles = this.allSystemRoles[i];
                for (var j = 0; j < systemRoles.boolList.length; j++) 
                    systemRoles.boolList[j].bool = false;
            }
        },
        async selectUser() {
            this.clearAllRoles();
            if (this.userId === null) 
                return;
            this.errMsg = '';
            let result = await AXIOS("/auth/getSystemRolesByUser", {userId: this.userId});
            if (result.success) {
                for (let i = 0; i < result.data.length; i++) {
                    let roleSystem = result.data[i];
                    this.systemRoleMap.get(roleSystem).bool = true;
                }
            } else {
                this.errMsg = result.errMsg;
            }
        },

        async saveAuthorization() {
            this.success = false;
            this.errMsg = '';
            if (this.userId == null) {
                this.errMsg = "Please select user first";
                return;
            }
            let checkedRoles = '';
            for (var i = 0; i < this.allSystemRoles.length; i++) {
                var systemRoles = this.allSystemRoles[i];
                var system = systemRoles.name;
                for (var j = 0; j < systemRoles.boolList.length; j++) {
                    let item = systemRoles.boolList[j];
                    if (item.bool) {
                        checkedRoles += item.name+"@"+system + ";";
                    }
                }
            }
            if (checkedRoles.length > 0) {
                checkedRoles = checkedRoles.substring(0, checkedRoles.length-1);
            }
            console.log(checkedRoles);

            let data = {userId: this.userId, checkedRoles: checkedRoles };
            this.loading = true;
            let result = await AXIOS("/auth/saveAuthorization", data);
            if (result.success) {
                this.success = true;
            } else {
                this.errMsg = result.errMsg;
            }
            this.loading = false;
        }
    }
}
</script>

<style scoped>
    .heading {
        text-align:center;
        color:#01b1af;
        font-family: Arial, Helvetica, sans-serif;
    }
    .role {
        color:#AAA;
        margin-right:20px;
        cursor:pointer;
    }
    span.active {
        color:#409eff;
        font-weight:bold;
    }
</style>